/* @ds-bundle: {"format":3,"namespace":"IAmGroundedDesignSystem_8b2731","components":[{"name":"AccordionItem","sourcePath":"components/commerce/AccordionItem.jsx"},{"name":"FeatureTile","sourcePath":"components/commerce/FeatureTile.jsx"},{"name":"FlavourCard","sourcePath":"components/commerce/FlavourCard.jsx"},{"name":"ProductCard","sourcePath":"components/commerce/ProductCard.jsx"},{"name":"SectionHeading","sourcePath":"components/commerce/SectionHeading.jsx"},{"name":"Badge","sourcePath":"components/core/Badge.jsx"},{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Pill","sourcePath":"components/core/Pill.jsx"},{"name":"Tag","sourcePath":"components/core/Tag.jsx"},{"name":"Input","sourcePath":"components/forms/Input.jsx"},{"name":"QuantityStepper","sourcePath":"components/forms/QuantityStepper.jsx"}],"sourceHashes":{"components/commerce/AccordionItem.jsx":"20d8a9edb987","components/commerce/FeatureTile.jsx":"a8a6cb00d7a1","components/commerce/FlavourCard.jsx":"14768188936b","components/commerce/ProductCard.jsx":"6758a9d74e21","components/commerce/SectionHeading.jsx":"77efe283488e","components/core/Badge.jsx":"58dbcaf2da66","components/core/Button.jsx":"0873cd7d5ec5","components/core/Pill.jsx":"4f68b24d43bc","components/core/Tag.jsx":"6bfc661a8843","components/forms/Input.jsx":"0fa2393ad684","components/forms/QuantityStepper.jsx":"320befe85a95","ui_kits/clusters-landing/app.jsx":"79e8bfb11092","ui_kits/clusters-landing/icons.jsx":"a52a7aa9a3fd","ui_kits/clusters-landing/sections-bottom.jsx":"cfe3b9d520c3","ui_kits/clusters-landing/sections-extra.jsx":"6d8e1119cfe6","ui_kits/clusters-landing/sections-mid.jsx":"938901ca61fb","ui_kits/clusters-landing/sections-top.jsx":"9b48ac0a2702"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.IAmGroundedDesignSystem_8b2731 = window.IAmGroundedDesignSystem_8b2731 || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/commerce/AccordionItem.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState
} = React;
/**
 * I Am Grounded — AccordionItem
 * Single FAQ row. Click to expand. Use several in a column with hairline
 * dividers. Self-contained (controlled or uncontrolled).
 */
function AccordionItem({
  question,
  children,
  defaultOpen = false,
  open,
  onToggle,
  ...rest
}) {
  const [internal, setInternal] = useState(defaultOpen);
  const isOpen = open !== undefined ? open : internal;
  const toggle = () => onToggle ? onToggle() : setInternal(v => !v);
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      borderBottom: "1.5px solid var(--iag-line)"
    }
  }, rest), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: toggle,
    "aria-expanded": isOpen,
    style: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      padding: "20px 4px",
      background: "transparent",
      border: "none",
      cursor: "pointer",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 700,
      fontSize: "17px",
      textTransform: "none",
      color: "var(--text-strong)",
      letterSpacing: "-0.005em"
    }
  }, question), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    style: {
      flex: "none",
      width: 30,
      height: 30,
      borderRadius: "50%",
      background: isOpen ? "var(--iag-terracotta)" : "var(--iag-terracotta-wash)",
      color: isOpen ? "#fff" : "var(--iag-terracotta-deep)",
      display: "grid",
      placeItems: "center",
      fontSize: 18,
      fontWeight: 700,
      transition: "background var(--dur-fast), transform var(--dur-mid) var(--ease-out)",
      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
      lineHeight: 1
    }
  }, "+")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateRows: isOpen ? "1fr" : "0fr",
      transition: "grid-template-rows var(--dur-mid) var(--ease-out)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "0 4px 22px",
      fontFamily: "var(--font-body)",
      fontSize: "15px",
      lineHeight: 1.6,
      color: "var(--text-body)",
      maxWidth: "62ch"
    }
  }, children))));
}
Object.assign(__ds_scope, { AccordionItem });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/AccordionItem.jsx", error: String((e && e.message) || e) }); }

// components/commerce/FeatureTile.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState
} = React;
/**
 * I Am Grounded — FeatureTile
 * Lifestyle "moment" tile: full-bleed image with a label + caption overlaid
 * on a soft ink scrim. Used in "Choose Your Moment" / "How to Eat Them".
 */
function FeatureTile({
  image,
  eyebrow,
  title,
  caption,
  height = 320,
  href,
  ...rest
}) {
  const [hover, setHover] = useState(false);
  return /*#__PURE__*/React.createElement("a", _extends({
    href: href || "#",
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      position: "relative",
      display: "block",
      height,
      borderRadius: "var(--radius-lg)",
      overflow: "hidden",
      boxShadow: hover ? "var(--shadow-lg)" : "var(--shadow-card)",
      transform: hover ? "translateY(-4px)" : "translateY(0)",
      transition: "transform var(--dur-mid) var(--ease-out), box-shadow var(--dur-mid)",
      textDecoration: "none"
    }
  }, rest), /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: title,
    style: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transform: hover ? "scale(1.05)" : "scale(1)",
      transition: "transform var(--dur-slow) var(--ease-out)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(to top, rgba(43,38,32,0.9) 0%, rgba(43,38,32,0.66) 34%, rgba(43,38,32,0.28) 62%, rgba(43,38,32,0) 100%)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      padding: "22px 22px 20px",
      color: "var(--iag-cream)"
    }
  }, eyebrow && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: "11.5px",
      letterSpacing: "0.16em",
      textTransform: "uppercase",
      color: "var(--iag-sunrise)",
      textShadow: "0 1px 5px rgba(0,0,0,0.6)"
    }
  }, eyebrow), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: "22px",
      textTransform: "uppercase",
      letterSpacing: "-0.01em",
      margin: "6px 0 0",
      color: "var(--iag-cream)",
      textShadow: "0 1px 8px rgba(0,0,0,0.5)"
    }
  }, title), caption && /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "14px",
      margin: "6px 0 0",
      opacity: 0.95,
      lineHeight: 1.45,
      textShadow: "0 1px 6px rgba(0,0,0,0.55)"
    }
  }, caption)));
}
Object.assign(__ds_scope, { FeatureTile });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/FeatureTile.jsx", error: String((e && e.message) || e) }); }

// components/commerce/SectionHeading.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * I Am Grounded — SectionHeading
 * Eyebrow kicker + display headline + optional lead. Centered or left.
 */
function SectionHeading({
  eyebrow,
  title,
  lead,
  align = "left",
  size = "l",
  maxWidth = "48ch",
  ...rest
}) {
  const fs = {
    m: "var(--fs-display-m)",
    l: "var(--fs-display-l)",
    xl: "var(--fs-display-xl)"
  }[size];
  return /*#__PURE__*/React.createElement("header", _extends({
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 14,
      alignItems: align === "center" ? "center" : "flex-start",
      textAlign: align
    }
  }, rest), eyebrow && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 700,
      fontSize: "var(--fs-eyebrow)",
      letterSpacing: "0.16em",
      textTransform: "uppercase",
      color: "var(--eyebrow)"
    }
  }, eyebrow), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: fs,
      lineHeight: "var(--lh-tight)",
      letterSpacing: "var(--ls-display)",
      textTransform: "uppercase",
      color: "var(--text-strong)",
      margin: 0,
      maxWidth,
      textWrap: "balance"
    }
  }, title), lead && /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "var(--fs-body-lg)",
      lineHeight: "var(--lh-normal)",
      color: "var(--text-body)",
      margin: 0,
      maxWidth: "56ch"
    }
  }, lead));
}
Object.assign(__ds_scope, { SectionHeading });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/SectionHeading.jsx", error: String((e && e.message) || e) }); }

// components/core/Badge.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * I Am Grounded — Badge
 * Tiny status flag for product cards: "Sale", "New", "Bestseller".
 * Uppercase Archivo, high-contrast.
 */
function Badge({
  children,
  tone = "cherry",
  ...rest
}) {
  const tones = {
    cherry: {
      bg: "var(--iag-cherry)",
      color: "#fff"
    },
    sunrise: {
      bg: "var(--iag-sunrise)",
      color: "var(--iag-ink)"
    },
    sky: {
      bg: "var(--iag-sky)",
      color: "var(--iag-ink)"
    },
    ink: {
      bg: "var(--iag-ink)",
      color: "var(--iag-cream)"
    },
    leaf: {
      bg: "var(--iag-leaf)",
      color: "#fff"
    }
  };
  const t = tones[tone] || tones.cherry;
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: "inline-flex",
      alignItems: "center",
      padding: "4px 10px",
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: "10.5px",
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      borderRadius: "var(--radius-pill)",
      background: t.bg,
      color: t.color,
      lineHeight: 1,
      whiteSpace: "nowrap"
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Badge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Badge.jsx", error: String((e && e.message) || e) }); }

// components/core/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState
} = React;
/**
 * I Am Grounded — Button
 * Tactile, pill-shaped CTA. Terracotta primary by default.
 * Variants: primary | secondary | outline | ghost
 * Sizes: sm | md | lg
 */
function Button({
  children,
  variant = "primary",
  size = "md",
  full = false,
  disabled = false,
  iconLeft = null,
  iconRight = null,
  as = "button",
  ...rest
}) {
  const [hover, setHover] = useState(false);
  const [press, setPress] = useState(false);
  const sizes = {
    sm: {
      padding: "8px 16px",
      fontSize: "14px",
      gap: "6px"
    },
    md: {
      padding: "13px 26px",
      fontSize: "15px",
      gap: "8px"
    },
    lg: {
      padding: "17px 34px",
      fontSize: "17px",
      gap: "10px"
    }
  };
  const palette = {
    primary: {
      bg: "var(--iag-terracotta)",
      bgHover: "var(--iag-terracotta-deep)",
      color: "var(--iag-white)",
      border: "transparent"
    },
    secondary: {
      bg: "var(--iag-ink)",
      bgHover: "#1c1813",
      color: "var(--iag-cream)",
      border: "transparent"
    },
    outline: {
      bg: "transparent",
      bgHover: "var(--iag-terracotta-wash)",
      color: "var(--iag-ink)",
      border: "var(--iag-ink)"
    },
    ghost: {
      bg: "transparent",
      bgHover: "var(--iag-terracotta-wash)",
      color: "var(--iag-terracotta-deep)",
      border: "transparent"
    }
  };
  const p = palette[variant] || palette.primary;
  const Tag = as;
  const style = {
    display: full ? "flex" : "inline-flex",
    width: full ? "100%" : "auto",
    alignItems: "center",
    justifyContent: "center",
    gap: sizes[size].gap,
    fontFamily: "var(--font-display)",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    fontSize: sizes[size].fontSize,
    padding: sizes[size].padding,
    borderRadius: "var(--radius-pill)",
    background: disabled ? "var(--iag-sand-deep)" : hover ? p.bgHover : p.bg,
    color: disabled ? "var(--iag-ink-3)" : p.color,
    border: `2px solid ${disabled ? "transparent" : p.border}`,
    cursor: disabled ? "not-allowed" : "pointer",
    boxShadow: variant === "primary" && !disabled ? "var(--shadow-sm)" : "none",
    transform: press && !disabled ? "scale(0.97)" : "scale(1)",
    transition: "background var(--dur-fast) var(--ease-out), transform var(--dur-fast) var(--ease-spring), box-shadow var(--dur-fast)",
    lineHeight: 1,
    whiteSpace: "nowrap",
    textDecoration: "none"
  };
  return /*#__PURE__*/React.createElement(Tag, _extends({
    style: style,
    disabled: as === "button" ? disabled : undefined,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => {
      setHover(false);
      setPress(false);
    },
    onMouseDown: () => setPress(true),
    onMouseUp: () => setPress(false)
  }, rest), iconLeft, children, iconRight);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/commerce/ProductCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState
} = React;
/**
 * I Am Grounded — ProductCard
 * Compact "Shop the Range" grid card: image, name, taste note, claim,
 * price, Add to Cart. Optional badge (Sale/New/Bundle).
 */
function ProductCard({
  name,
  tasteNote,
  claim,
  image,
  price = "$6.95",
  compareAt,
  badge,
  badgeTone = "cherry",
  flavour = "banana",
  onAdd,
  ctaLabel = "Add",
  ...rest
}) {
  const [hover, setHover] = useState(false);
  const wash = flavour === "choc" ? "var(--iag-sky-wash)" : flavour === "bundle" ? "var(--iag-kraft-wash)" : "var(--iag-sunrise-wash)";
  return /*#__PURE__*/React.createElement("article", _extends({
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: "flex",
      flexDirection: "column",
      background: "var(--surface-raised)",
      border: "1.5px solid var(--iag-line)",
      borderRadius: "var(--radius-lg)",
      overflow: "hidden",
      boxShadow: hover ? "var(--shadow-lg)" : "var(--shadow-sm)",
      transform: hover ? "translateY(-4px)" : "translateY(0)",
      transition: "transform var(--dur-mid) var(--ease-out), box-shadow var(--dur-mid)"
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      background: wash,
      aspectRatio: "1 / 1",
      display: "grid",
      placeItems: "center",
      overflow: "hidden"
    }
  }, badge && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 14,
      left: 14,
      zIndex: 1
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Badge, {
    tone: badgeTone
  }, badge)), /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: name,
    style: {
      width: "82%",
      height: "82%",
      objectFit: "contain",
      transform: hover ? "scale(1.04)" : "scale(1)",
      transition: "transform var(--dur-slow) var(--ease-out)",
      filter: "drop-shadow(0 12px 20px rgba(63,45,28,0.18))"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "18px 18px 20px",
      display: "flex",
      flexDirection: "column",
      gap: 6,
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: "16px",
      textTransform: "uppercase",
      letterSpacing: "-0.005em",
      lineHeight: 1.1,
      margin: 0,
      color: "var(--text-strong)"
    }
  }, name), tasteNote && /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "13.5px",
      lineHeight: 1.45,
      color: "var(--text-muted)",
      margin: 0
    }
  }, tasteNote), claim && /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "13px",
      fontWeight: 600,
      color: "var(--iag-terracotta-deep)",
      margin: "2px 0 0"
    }
  }, claim), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 10,
      paddingTop: 12
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "baseline",
      gap: 7
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: "18px",
      color: "var(--text-strong)"
    }
  }, price), compareAt && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "13px",
      color: "var(--text-muted)",
      textDecoration: "line-through"
    }
  }, compareAt)), /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "outline",
    size: "sm",
    onClick: onAdd
  }, ctaLabel))));
}
Object.assign(__ds_scope, { ProductCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/ProductCard.jsx", error: String((e && e.message) || e) }); }

// components/core/Pill.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * I Am Grounded — Pill (claim chip)
 * The brand's signature rounded claim chip. Two shapes:
 *  - "pill"   : horizontal lozenge ("71mg caffeine per bag")
 *  - "circle" : stacked numeric stamp ("71mg / Caffeine")
 */
function Pill({
  children,
  value,
  label,
  shape = "pill",
  tone = "terracotta",
  size = "md",
  iconLeft = null,
  ...rest
}) {
  const tones = {
    terracotta: {
      bg: "var(--iag-terracotta)",
      color: "#fff",
      border: "transparent"
    },
    sunrise: {
      bg: "var(--iag-sunrise)",
      color: "var(--iag-ink)",
      border: "transparent"
    },
    sky: {
      bg: "var(--iag-sky)",
      color: "var(--iag-ink)",
      border: "transparent"
    },
    kraft: {
      bg: "var(--iag-kraft)",
      color: "var(--iag-ink)",
      border: "transparent"
    },
    outline: {
      bg: "transparent",
      color: "var(--iag-ink)",
      border: "var(--iag-ink)"
    },
    soft: {
      bg: "var(--iag-terracotta-wash)",
      color: "var(--iag-terracotta-deep)",
      border: "transparent"
    }
  };
  const t = tones[tone] || tones.terracotta;
  if (shape === "circle") {
    const dim = size === "sm" ? 52 : size === "lg" ? 76 : 62;
    return /*#__PURE__*/React.createElement("span", _extends({
      style: {
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: dim,
        height: dim,
        borderRadius: "50%",
        background: t.bg,
        color: t.color,
        border: t.border === "transparent" ? "none" : `2px solid ${t.border}`,
        textAlign: "center",
        lineHeight: 1
      }
    }, rest), /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: "var(--font-display)",
        fontWeight: 900,
        fontSize: dim * 0.26
      }
    }, value), label && /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: dim * 0.12,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        marginTop: 3,
        fontWeight: 700
      }
    }, label));
  }
  const sizes = {
    sm: {
      padding: "6px 12px",
      fontSize: "12px"
    },
    md: {
      padding: "8px 16px",
      fontSize: "13px"
    },
    lg: {
      padding: "11px 22px",
      fontSize: "15px"
    }
  };
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: sizes[size].padding,
      fontSize: sizes[size].fontSize,
      fontFamily: "var(--font-body)",
      fontWeight: 700,
      borderRadius: "var(--radius-pill)",
      background: t.bg,
      color: t.color,
      border: t.border === "transparent" ? "none" : `2px solid ${t.border}`,
      whiteSpace: "nowrap",
      lineHeight: 1
    }
  }, rest), iconLeft, children);
}
Object.assign(__ds_scope, { Pill });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Pill.jsx", error: String((e && e.message) || e) }); }

// components/commerce/FlavourCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState
} = React;
/**
 * I Am Grounded — FlavourCard
 * Big "Meet the Flavours" card: tinted panel, pack image, role tag,
 * benefit list, claim stamps, price + Add to Cart. Themed per flavour.
 */
function FlavourCard({
  flavour = "banana",
  // "banana" | "choc"
  name,
  role,
  description,
  image,
  benefits = [],
  claims = [],
  // [{value,label}]
  price = "$6.95",
  perServe,
  // e.g. "$1.74 / serve"
  serves,
  // e.g. "4 serves per bag"
  onAdd,
  ctaLabel = "Add to cart",
  ...rest
}) {
  const [hover, setHover] = useState(false);
  const theme = flavour === "choc" ? {
    wash: "var(--iag-sky-wash)",
    accent: "var(--iag-sky-deep)",
    tone: "sky"
  } : {
    wash: "var(--iag-sunrise-wash)",
    accent: "var(--iag-sunrise-deep)",
    tone: "sunrise"
  };
  return /*#__PURE__*/React.createElement("article", _extends({
    "data-flavour": flavour,
    style: {
      display: "flex",
      flexDirection: "column",
      background: "var(--surface-raised)",
      border: "1.5px solid var(--iag-line)",
      borderRadius: "var(--radius-xl)",
      overflow: "hidden",
      boxShadow: "var(--shadow-card)"
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      position: "relative",
      background: theme.wash,
      padding: "28px 28px 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-end",
      minHeight: 280,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "iag-dotfield",
    style: {
      position: "absolute",
      inset: 0,
      color: theme.accent,
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 18,
      left: 18,
      zIndex: 2
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Pill, {
    tone: theme.tone,
    size: "sm"
  }, role)), /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: name,
    style: {
      position: "relative",
      zIndex: 1,
      maxHeight: 260,
      objectFit: "contain",
      transform: hover ? "translateY(-6px) rotate(-1deg)" : "translateY(0)",
      transition: "transform var(--dur-slow) var(--ease-out)",
      filter: "drop-shadow(0 18px 28px rgba(63,45,28,0.22))"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "26px 28px 28px",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: "26px",
      textTransform: "uppercase",
      letterSpacing: "-0.01em",
      lineHeight: 1.04,
      margin: 0,
      color: "var(--text-strong)"
    }
  }, name), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "15px",
      lineHeight: 1.55,
      color: "var(--text-body)",
      margin: "10px 0 0"
    }
  }, description)), claims.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 14,
      flexWrap: "wrap"
    }
  }, claims.map(c => /*#__PURE__*/React.createElement(__ds_scope.Pill, {
    key: c.label,
    shape: "circle",
    tone: theme.tone,
    value: c.value,
    label: c.label,
    size: "sm"
  }))), benefits.length > 0 && /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      margin: 0,
      padding: 0,
      display: "flex",
      flexDirection: "column",
      gap: 8
    }
  }, benefits.map(b => /*#__PURE__*/React.createElement("li", {
    key: b,
    style: {
      display: "flex",
      alignItems: "center",
      gap: 9,
      fontFamily: "var(--font-body)",
      fontSize: "14.5px",
      color: "var(--text-body)"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 7,
      height: 7,
      borderRadius: "50%",
      background: theme.accent,
      flex: "none"
    }
  }), b))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",
      gap: 14,
      paddingTop: 6
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 7
    }
  }, serves && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "12px",
      fontWeight: 600,
      color: "var(--text-muted)",
      textTransform: "uppercase",
      letterSpacing: "0.04em"
    }
  }, serves), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "baseline",
      gap: 9,
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: "24px",
      color: "var(--text-strong)"
    }
  }, price), perServe && /*#__PURE__*/React.createElement(__ds_scope.Pill, {
    tone: "soft",
    size: "sm"
  }, perServe))), /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "primary",
    onClick: onAdd
  }, ctaLabel))));
}
Object.assign(__ds_scope, { FlavourCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/commerce/FlavourCard.jsx", error: String((e && e.message) || e) }); }

// components/core/Tag.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState
} = React;
/**
 * I Am Grounded — Tag
 * Selectable category / filter chip (ingredients, moments, collections).
 * Outline by default; fills with ink when selected. Click to toggle.
 */
function Tag({
  children,
  selected = false,
  onToggle,
  iconLeft = null,
  ...rest
}) {
  const [hover, setHover] = useState(false);
  const active = selected;
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    onClick: onToggle,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 7,
      padding: "8px 16px",
      fontFamily: "var(--font-body)",
      fontWeight: 600,
      fontSize: "14px",
      borderRadius: "var(--radius-pill)",
      cursor: "pointer",
      lineHeight: 1,
      whiteSpace: "nowrap",
      background: active ? "var(--iag-ink)" : hover ? "var(--iag-sand)" : "var(--iag-white)",
      color: active ? "var(--iag-cream)" : "var(--iag-ink)",
      border: `1.5px solid ${active ? "var(--iag-ink)" : "var(--iag-line-strong)"}`,
      transition: "background var(--dur-fast) var(--ease-out), color var(--dur-fast)"
    }
  }, rest), iconLeft, children);
}
Object.assign(__ds_scope, { Tag });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Tag.jsx", error: String((e && e.message) || e) }); }

// components/forms/Input.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useState
} = React;
/**
 * I Am Grounded — Input
 * Warm-paper text field with optional label. Pill or soft-rounded.
 * Use for newsletter signup, search, checkout.
 */
function Input({
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  shape = "soft",
  // "soft" | "pill"
  invalid = false,
  iconLeft = null,
  id,
  ...rest
}) {
  const [focus, setFocus] = useState(false);
  const radius = shape === "pill" ? "var(--radius-pill)" : "var(--radius-sm)";
  const borderColor = invalid ? "var(--iag-error)" : focus ? "var(--iag-terracotta)" : "var(--iag-line-strong)";
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 7,
      width: "100%"
    }
  }, label && /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: 600,
      fontSize: "13.5px",
      color: "var(--text-strong)"
    }
  }, label), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      background: "var(--surface-raised)",
      border: `1.5px solid ${borderColor}`,
      borderRadius: radius,
      padding: shape === "pill" ? "0 20px" : "0 14px",
      boxShadow: focus ? "0 0 0 3px var(--iag-terracotta-wash)" : "none",
      transition: "border-color var(--dur-fast), box-shadow var(--dur-fast)"
    }
  }, iconLeft && /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--text-muted)",
      display: "flex"
    }
  }, iconLeft), /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: type,
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    style: {
      flex: 1,
      border: "none",
      outline: "none",
      background: "transparent",
      fontFamily: "var(--font-body)",
      fontSize: "15px",
      color: "var(--text-strong)",
      padding: "13px 0"
    }
  }, rest))));
}
Object.assign(__ds_scope, { Input });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Input.jsx", error: String((e && e.message) || e) }); }

// components/forms/QuantityStepper.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * I Am Grounded — QuantityStepper
 * Pill-shaped −/+ quantity control for cart lines & product pages.
 */
function QuantityStepper({
  value = 1,
  min = 1,
  max = 99,
  onChange,
  size = "md",
  ...rest
}) {
  const dim = size === "sm" ? 30 : 38;
  const set = next => {
    const v = Math.max(min, Math.min(max, next));
    onChange && onChange(v);
  };
  const btn = (label, fn, disabled) => /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: fn,
    disabled: disabled,
    style: {
      width: dim,
      height: dim,
      borderRadius: "50%",
      border: "none",
      background: "transparent",
      color: disabled ? "var(--iag-ink-3)" : "var(--iag-ink)",
      fontSize: size === "sm" ? 16 : 19,
      fontWeight: 700,
      cursor: disabled ? "not-allowed" : "pointer",
      display: "grid",
      placeItems: "center",
      lineHeight: 1,
      fontFamily: "var(--font-body)"
    }
  }, label);
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 2,
      background: "var(--surface-raised)",
      border: "1.5px solid var(--iag-line-strong)",
      borderRadius: "var(--radius-pill)",
      padding: 3
    }
  }, rest), btn("\u2212", () => set(value - 1), value <= min), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: size === "sm" ? 22 : 28,
      textAlign: "center",
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: size === "sm" ? 14 : 16,
      color: "var(--text-strong)"
    }
  }, value), btn("+", () => set(value + 1), value >= max));
}
Object.assign(__ds_scope, { QuantityStepper });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/QuantityStepper.jsx", error: String((e && e.message) || e) }); }

// ui_kits/clusters-landing/app.jsx
try { (() => {
/* I Am Grounded — Clusters Landing · App (cart state, mini-cart drawer, toast) */
const appDS = window.IAmGroundedDesignSystem_8b2731;
const AppIcon = window.IAGIcon;
const CATALOG = {
  banana: {
    name: "Banana, Coconut & Coffee Fruit",
    price: 6.95,
    image: "../../assets/imagery/pack-banana-track.png",
    flavour: "banana"
  },
  choc: {
    name: "Choc Crunch & Coffee Fruit",
    price: 6.95,
    image: "../../assets/imagery/pack-choc-pool.png",
    flavour: "choc"
  },
  bundle: {
    name: "Mixed Cluster Bundle",
    price: 12.50,
    image: "../../assets/imagery/banana-bowl-flatlay.png",
    flavour: "bundle"
  }
};
function MiniCart({
  open,
  items,
  onClose,
  setQty,
  removeItem
}) {
  const lines = Object.entries(items).filter(([, q]) => q > 0);
  const subtotal = lines.reduce((s, [id, q]) => s + CATALOG[id].price * q, 0);
  const freeShipAt = 60;
  const remaining = Math.max(0, freeShipAt - subtotal);
  const pct = Math.min(100, subtotal / freeShipAt * 100);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    style: {
      position: "fixed",
      inset: 0,
      background: "rgba(43,38,32,0.42)",
      opacity: open ? 1 : 0,
      pointerEvents: open ? "auto" : "none",
      transition: "opacity var(--dur-mid)",
      zIndex: 1000
    }
  }), /*#__PURE__*/React.createElement("aside", {
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      height: "100%",
      width: "min(420px, 92vw)",
      background: "var(--iag-cream)",
      boxShadow: "var(--shadow-lg)",
      zIndex: 1001,
      transform: open ? "translateX(0)" : "translateX(100%)",
      transition: "transform var(--dur-slow) var(--ease-out)",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "20px 22px",
      borderBottom: "1.5px solid var(--iag-line)"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: 18,
      textTransform: "uppercase",
      color: "var(--iag-ink)"
    }
  }, "Your cart"), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    "aria-label": "Close cart",
    style: {
      border: "none",
      background: "transparent",
      cursor: "pointer",
      color: "var(--iag-ink)",
      display: "grid",
      placeItems: "center"
    }
  }, /*#__PURE__*/React.createElement(AppIcon, {
    name: "x",
    size: 22
  }))), lines.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "14px 22px 6px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 13,
      color: "var(--text-body)",
      marginBottom: 8
    }
  }, remaining > 0 ? /*#__PURE__*/React.createElement("span", null, "Add ", /*#__PURE__*/React.createElement("b", null, "$", remaining.toFixed(2)), " for free shipping") : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "You've unlocked free shipping \u2713"))), /*#__PURE__*/React.createElement("div", {
    style: {
      height: 7,
      borderRadius: 99,
      background: "var(--iag-sand-deep)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%",
      width: pct + "%",
      background: "var(--iag-terracotta)",
      borderRadius: 99,
      transition: "width var(--dur-slow) var(--ease-out)"
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      overflowY: "auto",
      padding: "14px 22px"
    }
  }, lines.length === 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "center",
      padding: "60px 10px",
      color: "var(--text-muted)",
      fontFamily: "var(--font-body)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      placeItems: "center",
      marginBottom: 14
    }
  }, /*#__PURE__*/React.createElement(AppIcon, {
    name: "bag",
    size: 40,
    color: "var(--iag-line-strong)"
  })), "Your cart is empty.") : lines.map(([id, q]) => /*#__PURE__*/React.createElement("div", {
    key: id,
    style: {
      display: "flex",
      gap: 14,
      padding: "14px 0",
      borderBottom: "1px solid var(--iag-line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 64,
      height: 72,
      borderRadius: "var(--radius-sm)",
      overflow: "hidden",
      background: "var(--iag-white)",
      flex: "none",
      border: "1px solid var(--iag-line)"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CATALOG[id].image,
    alt: CATALOG[id].name,
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 700,
      fontSize: 13.5,
      textTransform: "uppercase",
      color: "var(--text-strong)",
      lineHeight: 1.2
    }
  }, CATALOG[id].name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 13,
      color: "var(--text-muted)",
      margin: "3px 0 10px"
    }
  }, "$", CATALOG[id].price.toFixed(2)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 10
    }
  }, /*#__PURE__*/React.createElement(appDS.QuantityStepper, {
    value: q,
    min: 0,
    max: 20,
    size: "sm",
    onChange: v => setQty(id, v)
  }), /*#__PURE__*/React.createElement("button", {
    onClick: () => removeItem(id),
    style: {
      border: "none",
      background: "transparent",
      fontFamily: "var(--font-body)",
      fontSize: 12.5,
      color: "var(--text-muted)",
      cursor: "pointer",
      textDecoration: "underline"
    }
  }, "Remove")))))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "18px 22px 24px",
      borderTop: "1.5px solid var(--iag-line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      marginBottom: 14
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: 600,
      fontSize: 15,
      color: "var(--text-body)"
    }
  }, "Subtotal"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: 22,
      color: "var(--text-strong)"
    }
  }, "$", subtotal.toFixed(2))), /*#__PURE__*/React.createElement(appDS.Button, {
    variant: "primary",
    size: "lg",
    full: true,
    disabled: lines.length === 0
  }, "Checkout"))));
}
function Toast({
  msg,
  show
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "fixed",
      left: "50%",
      bottom: 28,
      transform: `translateX(-50%) translateY(${show ? 0 : 20}px)`,
      opacity: show ? 1 : 0,
      pointerEvents: "none",
      transition: "all var(--dur-mid) var(--ease-out)",
      zIndex: 1100,
      background: "var(--iag-ink)",
      color: "var(--iag-cream)",
      padding: "13px 22px",
      borderRadius: "var(--radius-pill)",
      boxShadow: "var(--shadow-lg)",
      fontFamily: "var(--font-body)",
      fontWeight: 600,
      fontSize: 14,
      display: "flex",
      alignItems: "center",
      gap: 9
    }
  }, /*#__PURE__*/React.createElement(AppIcon, {
    name: "check",
    size: 18,
    color: "var(--iag-sunrise)"
  }), " ", msg);
}
function App() {
  const [cart, setCart] = React.useState({});
  const [cartOpen, setCartOpen] = React.useState(false);
  const [toast, setToast] = React.useState({
    show: false,
    msg: ""
  });
  const toastTimer = React.useRef(null);
  const flash = msg => {
    setToast({
      show: true,
      msg
    });
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(t => ({
      ...t,
      show: false
    })), 1900);
  };
  const add = id => {
    if (!id || !CATALOG[id]) return;
    setCart(c => ({
      ...c,
      [id]: (c[id] || 0) + 1
    }));
    flash(`Added ${CATALOG[id].name.split(",")[0]} to cart`);
    setCartOpen(true);
  };
  const setQty = (id, v) => setCart(c => ({
    ...c,
    [id]: v
  }));
  const removeItem = id => setCart(c => {
    const n = {
      ...c
    };
    delete n[id];
    return n;
  });
  const count = Object.values(cart).reduce((a, b) => a + b, 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(window.IAGHeader, {
    cartCount: count,
    onCartOpen: () => setCartOpen(true)
  }), /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement(window.IAGHero, {
    onAdd: () => add("banana")
  }), /*#__PURE__*/React.createElement(window.IAGMoments, null), /*#__PURE__*/React.createElement(window.IAGFlavours, {
    onAdd: add
  }), /*#__PURE__*/React.createElement(window.IAGBothShot, {
    onAdd: add
  }), /*#__PURE__*/React.createElement(window.IAGIngredients, null), /*#__PURE__*/React.createElement(window.IAGNutrition, null), /*#__PURE__*/React.createElement(window.IAGHowToEat, null), /*#__PURE__*/React.createElement(window.IAGCoffeeFruit, null), /*#__PURE__*/React.createElement(window.IAGTestimonials, null), /*#__PURE__*/React.createElement(window.IAGShopRange, {
    onAdd: add
  }), /*#__PURE__*/React.createElement(window.IAGFAQ, null), /*#__PURE__*/React.createElement(window.IAGNewsletter, null)), /*#__PURE__*/React.createElement(window.IAGFooter, null), /*#__PURE__*/React.createElement(MiniCart, {
    open: cartOpen,
    items: cart,
    onClose: () => setCartOpen(false),
    setQty: setQty,
    removeItem: removeItem
  }), /*#__PURE__*/React.createElement(Toast, {
    msg: toast.msg,
    show: toast.show
  }));
}
ReactDOM.createRoot(document.getElementById("root")).render(/*#__PURE__*/React.createElement(App, null));
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/clusters-landing/app.jsx", error: String((e && e.message) || e) }); }

// ui_kits/clusters-landing/icons.jsx
try { (() => {
/* I Am Grounded UI kit — Icon helper.
   Lucide (lucide.dev, ISC licence) 24×24 stroke icons, copied as path data
   to keep the kit self-contained. stroke-width 2, round caps/joins. */
(function () {
  const PATHS = {
    menu: "M4 12h16M4 6h16M4 18h16",
    search: "M21 21l-4.3-4.3 M11 19a8 8 0 100-16 8 8 0 000 16z",
    bag: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z M3 6h18 M16 10a4 4 0 0 1-8 0",
    "chevron-down": "M6 9l6 6 6-6",
    "chevron-right": "M9 18l6-6-6-6",
    "chevron-left": "M15 18l-6-6 6-6",
    "arrow-right": "M5 12h14 M13 5l7 7-7 7",
    leaf: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z M2 21c0-3 1.85-5.36 5.08-6",
    plus: "M5 12h14 M12 5v14",
    minus: "M5 12h14",
    check: "M20 6 9 17l-5-5",
    zap: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
    sprout: "M7 20h10 M10 20c5.5-2.5.8-6.4 3-10 M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
    coffee: "M10 2v2 M14 2v2 M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1 M6 2v2",
    recycle: "M7 19H4.8a2 2 0 0 1-1.7-3l.8-1.3 M11 19h8.3a2 2 0 0 0 1.7-3l-1.3-2.3 M9.3 5.3 11 2.4a2 2 0 0 1 3.4 0l1.6 2.7 M13.8 17.1 12 20 M7.9 9.3 4.5 9 M16.1 9.3l3.4-.3",
    star: "M11.5 2.6l2.3 4.8 5.2.7-3.8 3.6 1 5.2-4.7-2.6-4.6 2.6 1-5.2L4 8.1l5.2-.7z",
    truck: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2 M15 18H9 M19 18h2a1 1 0 0 0 1-1v-3.6a1 1 0 0 0-.3-.7l-2.4-2.4a1 1 0 0 0-.7-.3H14 M7 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M17 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    x: "M18 6 6 18 M6 6l12 12"
  };
  function Icon({
    name,
    size = 22,
    color = "currentColor",
    strokeWidth = 2,
    fill = "none",
    style
  }) {
    const d = PATHS[name];
    return React.createElement("svg", {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: fill,
      stroke: color,
      strokeWidth: strokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: {
        display: "block",
        flex: "none",
        ...style
      },
      "aria-hidden": "true"
    }, (d || "").split(" M").map((seg, i) => React.createElement("path", {
      key: i,
      d: i === 0 ? seg : "M" + seg
    })));
  }
  window.IAGIcon = Icon;
})();
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/clusters-landing/icons.jsx", error: String((e && e.message) || e) }); }

// ui_kits/clusters-landing/sections-bottom.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* I Am Grounded — Clusters Landing · BOTTOM sections (Shop the Range, FAQ, Newsletter, Footer) */
const botDS = window.IAmGroundedDesignSystem_8b2731;
const BotIcon = window.IAGIcon;
const PRODUCTS = [{
  id: "banana",
  flavour: "banana",
  name: "Banana Coconut",
  tasteNote: "Bright, crunchy, naturally caffeinated.",
  claim: "71mg caffeine · 6g fibre",
  image: "../../assets/imagery/pack-banana-track.png",
  price: "$6.95",
  badge: "New",
  badgeTone: "sunrise"
}, {
  id: "choc",
  flavour: "choc",
  name: "Choc Crunch",
  tasteNote: "Choc protein cluster with cashews & buckinis.",
  claim: "20g protein · 71mg caffeine",
  image: "../../assets/imagery/pack-choc-pool.png",
  price: "$6.95",
  badge: "Bestseller",
  badgeTone: "sky"
}, {
  id: "bundle",
  flavour: "bundle",
  name: "Mixed Cluster Bundle",
  tasteNote: "One of each — try both flavours.",
  claim: "Save on the pair",
  image: "../../assets/imagery/banana-bowl-flatlay.png",
  price: "$12.50",
  compareAt: "$13.90",
  badge: "Sale",
  badgeTone: "cherry"
}];
function ShopRange({
  onAdd
}) {
  return /*#__PURE__*/React.createElement("section", {
    id: "shop",
    style: {
      background: "var(--iag-cream)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
      gap: 24,
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement(botDS.SectionHeading, {
    eyebrow: "Shop the range",
    title: "Stock up & save."
  }), /*#__PURE__*/React.createElement(botDS.Button, {
    variant: "outline"
  }, "Try both flavours")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill,minmax(250px,1fr))",
      gap: 20,
      marginTop: 36
    }
  }, PRODUCTS.map(p => /*#__PURE__*/React.createElement(botDS.ProductCard, _extends({
    key: p.id
  }, p, {
    onAdd: () => onAdd(p.id)
  }))))));
}
function FAQ() {
  const [open, setOpen] = React.useState(0);
  const faqs = [{
    q: "Are the clusters caffeinated?",
    a: "Yes — every bag is naturally caffeinated using upcycled coffee fruit, not synthetic stimulants."
  }, {
    q: "How much caffeine is in each bag?",
    a: "Each 120g bag has 71mg of natural caffeine — about as much as one cup of coffee."
  }, {
    q: "What is coffee fruit?",
    a: "Coffee fruit (or coffeeberry) is the antioxidant-rich berry that surrounds the coffee bean, normally discarded after the beans are removed. We upcycle it into functional snacks."
  }, {
    q: "Are they plant-based?",
    a: "Yes. Both Banana Coconut and Choc Crunch are plant-based, made with real wholefood ingredients."
  }, {
    q: "How should I eat them?",
    a: "Snack straight from the bag, sprinkle over yoghurt or smoothie bowls, or keep a bag close for your next energy dip."
  }, {
    q: "Are they suitable for kids or pregnancy?",
    a: "These products contain caffeine. As with any caffeinated food, we recommend caution for children and those who are pregnant or breastfeeding — please consult your health professional."
  }];
  return /*#__PURE__*/React.createElement("section", {
    id: "faq",
    style: {
      background: "var(--iag-sand)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 820,
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      marginBottom: 28
    }
  }, /*#__PURE__*/React.createElement(botDS.SectionHeading, {
    align: "center",
    eyebrow: "Good to know",
    title: "Your questions, answered.",
    maxWidth: "20ch"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--surface-raised)",
      border: "1.5px solid var(--iag-line)",
      borderRadius: "var(--radius-xl)",
      padding: "6px 28px",
      boxShadow: "var(--shadow-card)"
    }
  }, faqs.map((f, i) => /*#__PURE__*/React.createElement(botDS.AccordionItem, {
    key: i,
    question: f.q,
    open: open === i,
    onToggle: () => setOpen(open === i ? -1 : i)
  }, f.a)))));
}
function Newsletter() {
  const [email, setEmail] = React.useState("");
  const [done, setDone] = React.useState(false);
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--iag-sunrise)",
      position: "relative",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "iag-dotfield",
    style: {
      position: "absolute",
      inset: 0,
      color: "var(--iag-ink)",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 720,
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)",
      textAlign: "center",
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      textTransform: "uppercase",
      fontSize: "var(--fs-display-m)",
      lineHeight: 1.02,
      letterSpacing: "-0.02em",
      color: "var(--iag-ink)",
      margin: 0
    }
  }, "Track. Ride. Work. Repeat."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "var(--fs-body-lg)",
      color: "var(--iag-ink)",
      margin: "14px auto 0",
      maxWidth: "40ch"
    }
  }, "Join the crew for launch offers, recipes and clean-energy tips. 10% off your first order."), /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      if (email) setDone(true);
    },
    style: {
      display: "flex",
      gap: 10,
      maxWidth: 480,
      margin: "26px auto 0",
      flexWrap: "wrap",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: "1 1 240px"
    }
  }, /*#__PURE__*/React.createElement(botDS.Input, {
    shape: "pill",
    type: "email",
    placeholder: "you@email.com",
    value: email,
    onChange: e => setEmail(e.target.value)
  })), /*#__PURE__*/React.createElement(botDS.Button, {
    variant: "secondary",
    size: "lg",
    type: "submit"
  }, done ? "You're in ✓" : "Get 10% off"))));
}
function Footer() {
  const cols = [{
    h: "Shop",
    links: ["Banana Coconut", "Choc Crunch", "Mixed bundle", "SUPR Bars", "Coffee beans"]
  }, {
    h: "Learn",
    links: ["Coffee fruit", "Our story", "Mission", "Ambassadors", "Stockists"]
  }, {
    h: "Help",
    links: ["Shipping", "Returns", "Contact", "Wholesale", "FAQs"]
  }];
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      background: "var(--iag-ink)",
      color: "var(--iag-cream)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      padding: "64px var(--gutter) 40px",
      display: "grid",
      gridTemplateColumns: "1.4fr 1fr 1fr 1fr",
      gap: 36
    },
    className: "iag-footer-grid"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 11
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/brand/icon-plant-light.png",
    alt: "I Am Grounded",
    style: {
      height: 42,
      width: "auto",
      display: "block"
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: 18,
      textTransform: "uppercase",
      color: "var(--iag-cream)"
    }
  }, "I Am Grounded")), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 14,
      color: "rgba(251,244,233,0.66)",
      margin: "16px 0 0",
      maxWidth: "30ch",
      lineHeight: 1.55
    }
  }, "Grounded in purpose. Fuelled by passion. Naturally caffeinated snacks from upcycled coffee fruit. Made in AUS.")), cols.map(c => /*#__PURE__*/React.createElement("div", {
    key: c.h
  }, /*#__PURE__*/React.createElement("h4", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 12,
      letterSpacing: ".12em",
      textTransform: "uppercase",
      color: "var(--iag-sunrise)",
      margin: "0 0 14px"
    }
  }, c.h), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      margin: 0,
      padding: 0,
      display: "flex",
      flexDirection: "column",
      gap: 9
    }
  }, c.links.map(l => /*#__PURE__*/React.createElement("li", {
    key: l
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 14,
      color: "rgba(251,244,233,0.8)",
      textDecoration: "none"
    }
  }, l))))))), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: "1px solid rgba(251,244,233,0.14)",
      padding: "20px var(--gutter)",
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      display: "flex",
      justifyContent: "space-between",
      gap: 16,
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 12.5,
      color: "rgba(251,244,233,0.55)"
    }
  }, "\xA9 2026 I Am Grounded. All rights reserved."), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 12.5,
      color: "rgba(251,244,233,0.55)"
    }
  }, "Free shipping on orders over $60 \xB7 Afterpay available")));
}
Object.assign(window, {
  IAGShopRange: ShopRange,
  IAGFAQ: FAQ,
  IAGNewsletter: Newsletter,
  IAGFooter: Footer,
  IAG_PRODUCTS: PRODUCTS
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/clusters-landing/sections-bottom.jsx", error: String((e && e.message) || e) }); }

// ui_kits/clusters-landing/sections-extra.jsx
try { (() => {
/* I Am Grounded — Clusters Landing · Nutrition + Ingredients, Testimonials carousel */
const exDS = window.IAmGroundedDesignSystem_8b2731;
const ExIcon = window.IAGIcon;
const NUTRITION = {
  banana: {
    label: "Banana, Coconut & Coffee Fruit",
    role: "The Brain Booster",
    ingredients: ["Wholegrain oats", "Banana", "Coconut", "Coffee fruit (coffeeberry)", "Pepitas", "Sunflower seeds", "Rice malt syrup"],
    rows: [{
      k: "Energy",
      serve: "139 Cal",
      bag: "556 Cal"
    }, {
      k: "Protein",
      serve: "3.5 g",
      bag: "14 g"
    }, {
      k: "Dietary fibre",
      serve: "1.5 g",
      bag: "6 g"
    }, {
      k: "Caffeine",
      serve: "~18 mg",
      bag: "71 mg"
    }]
  },
  choc: {
    label: "Choc Crunch & Coffee Fruit",
    role: "Recovery + Focus",
    ingredients: ["Wholegrain oats", "Coffee fruit (coffeeberry)", "Cashews", "Pea protein crisps", "Cocoa", "Buckinis (activated buckwheat)", "Pepitas"],
    rows: [{
      k: "Energy",
      serve: "162 Cal",
      bag: "648 Cal"
    }, {
      k: "Protein",
      serve: "5 g",
      bag: "20 g"
    }, {
      k: "Dietary fibre",
      serve: "1.75 g",
      bag: "7 g"
    }, {
      k: "Caffeine",
      serve: "~18 mg",
      bag: "71 mg"
    }]
  }
};
function Nutrition() {
  const [flav, setFlav] = React.useState("banana");
  const d = NUTRITION[flav];
  const theme = flav === "choc" ? {
    accent: "var(--iag-sky-deep)",
    wash: "var(--iag-sky-wash)",
    chip: "sky"
  } : {
    accent: "var(--iag-sunrise-deep)",
    wash: "var(--iag-sunrise-wash)",
    chip: "sunrise"
  };
  const seg = (id, label) => {
    const on = flav === id;
    return /*#__PURE__*/React.createElement("button", {
      key: id,
      onClick: () => setFlav(id),
      style: {
        flex: 1,
        padding: "12px 18px",
        border: "none",
        cursor: "pointer",
        borderRadius: "var(--radius-pill)",
        fontFamily: "var(--font-display)",
        fontWeight: 700,
        fontSize: 13,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        background: on ? "var(--iag-ink)" : "transparent",
        color: on ? "var(--iag-cream)" : "var(--iag-ink)",
        transition: "background var(--dur-fast), color var(--dur-fast)",
        whiteSpace: "nowrap"
      }
    }, label);
  };
  return /*#__PURE__*/React.createElement("section", {
    id: "nutrition",
    style: {
      background: "var(--iag-cream)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)"
    }
  }, /*#__PURE__*/React.createElement(exDS.SectionHeading, {
    eyebrow: "Ingredients & nutrition",
    title: "Know exactly what you're eating.",
    lead: "Real, recognisable ingredients and a clean nutritional profile. Toggle a flavour to see the full breakdown."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-flex",
      gap: 4,
      background: "var(--surface-raised)",
      border: "1.5px solid var(--iag-line-strong)",
      borderRadius: "var(--radius-pill)",
      padding: 4,
      margin: "28px 0 26px"
    }
  }, seg("banana", "Banana Coconut"), seg("choc", "Choc Crunch")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 24
    },
    className: "iag-nutri-grid"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--surface-raised)",
      border: "1.5px solid var(--iag-line)",
      borderRadius: "var(--radius-xl)",
      boxShadow: "var(--shadow-card)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: theme.wash,
      padding: "22px 26px",
      display: "flex",
      alignItems: "center",
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 40,
      height: 40,
      borderRadius: "50%",
      background: "var(--surface-raised)",
      display: "grid",
      placeItems: "center",
      color: theme.accent
    }
  }, /*#__PURE__*/React.createElement(ExIcon, {
    name: "leaf",
    size: 20,
    color: theme.accent
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 17,
      textTransform: "uppercase",
      color: "var(--text-strong)",
      lineHeight: 1
    }
  }, "What's inside"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 12.5,
      color: "var(--text-muted)",
      marginTop: 4
    }
  }, d.label))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "22px 26px 26px",
      display: "flex",
      flexWrap: "wrap",
      gap: 9
    }
  }, d.ingredients.map(ing => /*#__PURE__*/React.createElement("span", {
    key: ing,
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 7,
      padding: "9px 15px",
      borderRadius: "var(--radius-pill)",
      background: "var(--iag-cream)",
      border: "1.5px solid var(--iag-line)",
      fontFamily: "var(--font-body)",
      fontWeight: 600,
      fontSize: 13.5,
      color: "var(--text-strong)"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 7,
      height: 7,
      borderRadius: "50%",
      background: theme.accent
    }
  }), ing)))), /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--surface-raised)",
      border: "1.5px solid var(--iag-line)",
      borderRadius: "var(--radius-xl)",
      boxShadow: "var(--shadow-card)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: "var(--iag-ink)",
      padding: "22px 26px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 17,
      textTransform: "uppercase",
      color: "var(--iag-cream)",
      lineHeight: 1
    }
  }, "Nutrition snapshot"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 12,
      fontWeight: 600,
      color: "var(--iag-sunrise)",
      textAlign: "right"
    }
  }, "4 serves per bag", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    style: {
      color: "rgba(251,244,233,0.7)"
    }
  }, "Serve size 30g \xB7 120g bag"))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "8px 26px 14px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.4fr 1fr 1fr",
      padding: "14px 0 12px",
      borderBottom: "2px solid var(--iag-ink)"
    }
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 11,
      textTransform: "uppercase",
      letterSpacing: "0.06em",
      color: "var(--text-muted)",
      textAlign: "right"
    }
  }, "Per serve"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 11,
      textTransform: "uppercase",
      letterSpacing: "0.06em",
      color: theme.accent,
      textAlign: "right"
    }
  }, "Per bag")), d.rows.map(r => /*#__PURE__*/React.createElement("div", {
    key: r.k,
    style: {
      display: "grid",
      gridTemplateColumns: "1.4fr 1fr 1fr",
      padding: "14px 0",
      borderBottom: "1px solid var(--iag-line)",
      alignItems: "baseline"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontWeight: 600,
      fontSize: 15,
      color: "var(--text-strong)"
    }
  }, r.k), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 15,
      color: "var(--text-body)",
      textAlign: "right"
    }
  }, r.serve), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: 16,
      color: "var(--text-strong)",
      textAlign: "right"
    }
  }, r.bag))), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 11.5,
      color: "var(--text-muted)",
      margin: "14px 0 4px",
      lineHeight: 1.5
    }
  }, "Indicative figures from current pack callouts. Full Nutrition Information Panel (fat, sugars, sodium) and the ordered ingredient + allergen list are confirmed on the approved pack."))))));
}
const TESTIMONIALS = [{
  quote: "Clean energy that actually sits well before a session. Banana Coconut is my new pre-run go-to — crunchy, and no crash.",
  name: "Lauren Hume",
  role: "Professional Triathlete",
  flavour: "banana"
}, {
  quote: "Choc Crunch after a long ride hits perfectly. Real food, real protein, and the coffee fruit lift keeps me focused.",
  name: "Thales Da Silva",
  role: "Elite AG Triathlete",
  flavour: "choc"
}, {
  quote: "Finally a snack that tastes amazing and keeps me going between matches. I keep a bag in every kit bag.",
  name: "Daisy Mumby",
  role: "Semi-Pro Beach Volleyballer",
  flavour: "banana"
}, {
  quote: "I coach athletes on fuelling properly — these tick every box. Natural caffeine, great macros, no nasties.",
  name: "Brett Hallam",
  role: "Elite Age-Group Triathlete · Coach",
  flavour: "choc"
}, {
  quote: "The 3pm desk slump never stood a chance. Grab a handful, back to work, no jitters.",
  name: "Oli Wright",
  role: "Elite AG Triathlete",
  flavour: "banana"
}];
function Testimonials() {
  const [i, setI] = React.useState(0);
  const [paused, setPaused] = React.useState(false);
  const n = TESTIMONIALS.length;
  React.useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setI(v => (v + 1) % n), 5500);
    return () => clearInterval(t);
  }, [paused, n]);
  const go = dir => setI(v => (v + dir + n) % n);
  const t = TESTIMONIALS[i];
  const accent = t.flavour === "choc" ? "var(--iag-sky)" : "var(--iag-sunrise)";
  const initials = t.name.split(" ").map(w => w[0]).join("").slice(0, 2);
  const arrow = (dir, name) => /*#__PURE__*/React.createElement("button", {
    onClick: () => go(dir),
    "aria-label": name,
    style: {
      width: 48,
      height: 48,
      borderRadius: "50%",
      border: "1.5px solid var(--iag-line-strong)",
      background: "var(--surface-raised)",
      cursor: "pointer",
      display: "grid",
      placeItems: "center",
      color: "var(--iag-ink)",
      flex: "none"
    }
  }, /*#__PURE__*/React.createElement(ExIcon, {
    name: dir < 0 ? "chevron-left" : "chevron-right",
    size: 22
  }));
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--iag-sand)"
    },
    onMouseEnter: () => setPaused(true),
    onMouseLeave: () => setPaused(false)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 980,
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      marginBottom: 36
    }
  }, /*#__PURE__*/React.createElement(exDS.SectionHeading, {
    align: "center",
    eyebrow: "From the crew",
    title: "Fuelled by the best.",
    maxWidth: "20ch"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "iag-testi-arrow"
  }, arrow(-1, "Previous")), /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "iag-testi-card",
    style: {
      flex: 1,
      background: "var(--surface-raised)",
      border: "1.5px solid var(--iag-line)",
      borderRadius: "var(--radius-2xl)",
      boxShadow: "var(--shadow-card)",
      padding: "clamp(28px,4vw,48px)",
      textAlign: "center",
      position: "relative",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 6,
      background: accent
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      gap: 4,
      marginBottom: 20
    }
  }, [0, 1, 2, 3, 4].map(s => /*#__PURE__*/React.createElement(ExIcon, {
    key: s,
    name: "star",
    size: 20,
    color: "var(--iag-sunrise-deep)",
    fill: "var(--iag-sunrise)"
  }))), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 700,
      fontSize: "clamp(1.25rem,2.4vw,1.75rem)",
      lineHeight: 1.3,
      letterSpacing: "-0.01em",
      color: "var(--text-strong)",
      margin: 0,
      textWrap: "balance"
    }
  }, "\u201C", t.quote, "\u201D"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 13,
      marginTop: 26
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 50,
      height: 50,
      borderRadius: "50%",
      background: accent,
      display: "grid",
      placeItems: "center",
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: 17,
      color: "var(--iag-ink)"
    }
  }, initials), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 16,
      textTransform: "uppercase",
      color: "var(--text-strong)",
      lineHeight: 1.1
    }
  }, t.name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 13,
      color: "var(--text-muted)",
      marginTop: 3
    }
  }, t.role)))), /*#__PURE__*/React.createElement("div", {
    className: "iag-testi-arrow"
  }, arrow(1, "Next"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      gap: 8,
      marginTop: 26
    }
  }, TESTIMONIALS.map((_, idx) => /*#__PURE__*/React.createElement("button", {
    key: idx,
    onClick: () => setI(idx),
    "aria-label": "Go to " + (idx + 1),
    style: {
      width: idx === i ? 26 : 9,
      height: 9,
      borderRadius: 99,
      border: "none",
      cursor: "pointer",
      padding: 0,
      background: idx === i ? "var(--iag-terracotta)" : "var(--iag-line-strong)",
      transition: "all var(--dur-mid) var(--ease-out)"
    }
  })))));
}
Object.assign(window, {
  IAGNutrition: Nutrition,
  IAGTestimonials: Testimonials
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/clusters-landing/sections-extra.jsx", error: String((e && e.message) || e) }); }

// ui_kits/clusters-landing/sections-mid.jsx
try { (() => {
/* I Am Grounded — Clusters Landing · MID sections
   (Meet the Flavours, Both Flavours shot, Real Ingredients, How to Eat, Coffee Fruit) */
const midDS = window.IAmGroundedDesignSystem_8b2731;
const MidIcon = window.IAGIcon;
function Flavours({
  onAdd
}) {
  return /*#__PURE__*/React.createElement("section", {
    id: "flavours",
    style: {
      background: "var(--iag-cream)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1080,
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      marginBottom: 40
    }
  }, /*#__PURE__*/React.createElement(midDS.SectionHeading, {
    align: "center",
    eyebrow: "Meet the flavours",
    title: "Two ways to fuel your day.",
    lead: "Give each cluster its moment \u2014 bright morning energy, or active recovery with function.",
    maxWidth: "22ch"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 24
    },
    className: "iag-flavours-grid"
  }, /*#__PURE__*/React.createElement(midDS.FlavourCard, {
    flavour: "banana",
    name: "Banana, Coconut & Coffee Fruit",
    role: "The Brain Booster",
    description: "Bright, crunchy and naturally caffeinated. Made for morning movement, breakfast bowls and clean energy on the go.",
    image: "../../assets/imagery/pack-banana-track.png",
    claims: [{
      value: "71mg",
      label: "Caffeine"
    }, {
      value: "14g",
      label: "Protein"
    }, {
      value: "6g",
      label: "Fibre"
    }, {
      value: "139",
      label: "Cal"
    }],
    benefits: ["Plant-based", "Natural energy", "Antioxidant rich"],
    price: "$6.95",
    serves: "4 serves per bag",
    perServe: "$1.74 / serve",
    onAdd: () => onAdd("banana")
  }), /*#__PURE__*/React.createElement(midDS.FlavourCard, {
    flavour: "choc",
    name: "Choc Crunch & Coffee Fruit",
    role: "Recovery + Focus",
    description: "A crunchy choc protein cluster with coffee fruit, oats, cashews, pea protein crisps, cocoa and buckinis.",
    image: "../../assets/imagery/pack-choc-pool.png",
    claims: [{
      value: "20g",
      label: "Protein"
    }, {
      value: "71mg",
      label: "Caffeine"
    }, {
      value: "7g",
      label: "Fibre"
    }, {
      value: "162",
      label: "Cal"
    }],
    benefits: ["Plant-based", "Active recovery", "Antioxidant rich"],
    price: "$6.95",
    serves: "4 serves per bag",
    perServe: "$1.74 / serve",
    onAdd: () => onAdd("choc")
  }))));
}
function BothShot({
  onAdd
}) {
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--iag-terracotta)",
      color: "#fff",
      position: "relative",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "iag-dotfield",
    style: {
      position: "absolute",
      inset: 0,
      color: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)",
      position: "relative",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "clamp(24px,5vw,56px)",
      alignItems: "center"
    },
    className: "iag-both-grid"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderRadius: "var(--radius-2xl)",
      overflow: "hidden",
      boxShadow: "var(--shadow-lg)",
      aspectRatio: "5/4"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/imagery/banana-bowl-flatlay.png",
    alt: "Both flavours with ingredients",
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 700,
      fontSize: 13,
      letterSpacing: ".16em",
      textTransform: "uppercase",
      color: "var(--iag-sunrise)"
    }
  }, "The full range"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      textTransform: "uppercase",
      fontSize: "var(--fs-display-l)",
      lineHeight: 1,
      letterSpacing: "-0.02em",
      margin: "14px 0 0"
    }
  }, "Real ingredients,", /*#__PURE__*/React.createElement("br", null), "in every bag."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "var(--fs-body-lg)",
      lineHeight: 1.55,
      margin: "18px 0 0",
      maxWidth: "42ch",
      color: "rgba(255,255,255,0.92)"
    }
  }, "Banana, coconut, oats and red coffee cherries. Cocoa, cashews, pepitas and buckinis. No nasties or unpronounceable ingredients \u2014 just wholefoods baked into crunchy clusters."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 12,
      marginTop: 28,
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement(midDS.Button, {
    variant: "secondary",
    size: "lg",
    onClick: () => onAdd("bundle")
  }, "Shop the bundle"), /*#__PURE__*/React.createElement(midDS.Button, {
    variant: "ghost",
    size: "lg",
    style: {
      color: "#fff"
    },
    iconRight: /*#__PURE__*/React.createElement(MidIcon, {
      name: "arrow-right",
      size: 18,
      color: "#fff"
    })
  }, "See all flavours")))));
}
function Ingredients() {
  const items = [{
    icon: "coffee",
    name: "Coffee fruit",
    note: "Natural caffeine + antioxidants"
  }, {
    icon: "sprout",
    name: "Oats",
    note: "Wholegrain, steady energy"
  }, {
    icon: "leaf",
    name: "Coconut",
    note: "Crunch & healthy fats"
  }, {
    icon: "zap",
    name: "Cocoa",
    note: "Better-for-you choc craving"
  }, {
    icon: "sprout",
    name: "Cashews",
    note: "Plant protein & bite"
  }, {
    icon: "star",
    name: "Buckinis",
    note: "Activated buckwheat crunch"
  }, {
    icon: "leaf",
    name: "Pepitas",
    note: "Pumpkin seed minerals"
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--iag-cream)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)"
    }
  }, /*#__PURE__*/React.createElement(midDS.SectionHeading, {
    eyebrow: "What's inside",
    title: "Real ingredients. Real crunch.",
    lead: "No nasties, no un-pronounceable ingredients. Just coffee fruit, oats and wholefood ingredients baked into crunchy clusters."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill,minmax(150px,1fr))",
      gap: 14,
      marginTop: 38
    }
  }, items.map((it, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    style: {
      background: "var(--surface-raised)",
      border: "1.5px solid var(--iag-line)",
      borderRadius: "var(--radius-lg)",
      padding: "20px 18px",
      boxShadow: "var(--shadow-xs)"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 44,
      height: 44,
      borderRadius: "50%",
      background: "var(--iag-terracotta-wash)",
      color: "var(--iag-terracotta-deep)",
      display: "grid",
      placeItems: "center"
    }
  }, /*#__PURE__*/React.createElement(MidIcon, {
    name: it.icon,
    size: 22,
    color: "var(--iag-terracotta-deep)"
  })), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 16,
      textTransform: "uppercase",
      margin: "14px 0 4px",
      color: "var(--text-strong)"
    }
  }, it.name), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 13,
      color: "var(--text-muted)",
      margin: 0,
      lineHeight: 1.4
    }
  }, it.note))))));
}
function HowToEat() {
  const [tab, setTab] = React.useState("Straight from the bag");
  const tabs = ["Straight from the bag", "On yoghurt or bowls", "After training", "At your desk"];
  const copy = {
    "Straight from the bag": {
      img: "../../assets/imagery/choc-desk.png",
      text: "Snack straight from the bag for a fast, crunchy energy hit — no spoon, no fuss."
    },
    "On yoghurt or bowls": {
      img: "../../assets/imagery/banana-breakfast-bowl.png",
      text: "Sprinkle over yoghurt, smoothie bowls and porridge for crunch, fibre and clean caffeine."
    },
    "After training": {
      img: "../../assets/imagery/pack-choc-pool.png",
      text: "Choc Crunch packs 20g protein per bag — built for active recovery after the session."
    },
    "At your desk": {
      img: "../../assets/imagery/choc-desk.png",
      text: "Keep a bag close for your next energy dip instead of reaching for another coffee."
    }
  };
  const active = copy[tab];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--iag-sand)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)"
    }
  }, /*#__PURE__*/React.createElement(midDS.SectionHeading, {
    eyebrow: "How to eat them",
    title: "Easy energy, any time of day."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 10,
      flexWrap: "wrap",
      margin: "26px 0 30px"
    }
  }, tabs.map(t => /*#__PURE__*/React.createElement(midDS.Tag, {
    key: t,
    selected: tab === t,
    onToggle: () => setTab(t)
  }, t))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.1fr 0.9fr",
      gap: 28,
      alignItems: "center",
      background: "var(--surface-raised)",
      borderRadius: "var(--radius-xl)",
      overflow: "hidden",
      border: "1.5px solid var(--iag-line)",
      boxShadow: "var(--shadow-card)"
    },
    className: "iag-howto-grid"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      aspectRatio: "5/4",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: active.img,
    alt: tab,
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "10px 36px 10px 10px"
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 800,
      fontSize: 24,
      textTransform: "uppercase",
      letterSpacing: "-0.01em",
      color: "var(--text-strong)",
      margin: 0
    }
  }, tab), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "var(--fs-body-lg)",
      lineHeight: 1.55,
      color: "var(--text-body)",
      margin: "14px 0 0"
    }
  }, active.text)))));
}
function CoffeeFruit() {
  const stats = [{
    n: "55,000kg",
    l: "Coffee fruit upcycled & counting"
  }, {
    n: "500,000+",
    l: "Snacks distributed"
  }, {
    n: "Caldas, Colombia",
    l: "Micro-lot farm partners"
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--iag-ink)",
      color: "var(--iag-cream)",
      position: "relative",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "clamp(28px,5vw,64px)",
      alignItems: "center"
    },
    className: "iag-coffee-grid"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 700,
      fontSize: 13,
      letterSpacing: ".16em",
      textTransform: "uppercase",
      color: "var(--iag-sunrise)",
      display: "inline-flex",
      alignItems: "center",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(MidIcon, {
    name: "recycle",
    size: 17,
    color: "var(--iag-sunrise)"
  }), " Upcycled purpose"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      textTransform: "uppercase",
      fontSize: "var(--fs-display-l)",
      lineHeight: 1,
      letterSpacing: "-0.02em",
      margin: "16px 0 0",
      color: "var(--iag-cream)"
    }
  }, "Powered by the fruit of the coffee plant."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "var(--fs-body-lg)",
      lineHeight: 1.6,
      margin: "20px 0 0",
      maxWidth: "44ch",
      color: "rgba(251,244,233,0.82)"
    }
  }, "Coffee fruit is the antioxidant-rich berry that surrounds the coffee bean \u2014 usually discarded after the beans are removed. It has ", /*#__PURE__*/React.createElement("strong", {
    style: {
      color: "var(--iag-cream)",
      fontWeight: 700
    }
  }, "no coffee taste"), ", but all the antioxidant benefits. We upcycle it into functional snacks with natural caffeine and real-food ingredients."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 30,
      flexWrap: "wrap",
      marginTop: 34
    }
  }, stats.map(s => /*#__PURE__*/React.createElement("div", {
    key: s.l
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      fontSize: 26,
      color: "var(--iag-sunrise)"
    }
  }, s.n), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: 13,
      color: "rgba(251,244,233,0.7)",
      maxWidth: "16ch",
      marginTop: 4
    }
  }, s.l))))), /*#__PURE__*/React.createElement("div", {
    style: {
      borderRadius: "var(--radius-2xl)",
      overflow: "hidden",
      boxShadow: "var(--shadow-lg)",
      aspectRatio: "4/4.4"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/imagery/banana-breakfast-bowl.png",
    alt: "Coffee fruit clusters",
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  }))));
}
Object.assign(window, {
  IAGFlavours: Flavours,
  IAGBothShot: BothShot,
  IAGIngredients: Ingredients,
  IAGHowToEat: HowToEat,
  IAGCoffeeFruit: CoffeeFruit
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/clusters-landing/sections-mid.jsx", error: String((e && e.message) || e) }); }

// ui_kits/clusters-landing/sections-top.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* I Am Grounded — Clusters Landing · TOP sections (Header, Hero, Moments) */
const DS = window.IAmGroundedDesignSystem_8b2731;
const Icon = window.IAGIcon;
const topStyles = {
  header: {
    position: "sticky",
    top: 0,
    zIndex: 200,
    background: "rgba(251,244,233,0.86)",
    backdropFilter: "blur(12px)",
    borderBottom: "1.5px solid var(--iag-line)"
  },
  headerInner: {
    maxWidth: "var(--max-w)",
    margin: "0 auto",
    padding: "0 var(--gutter)",
    height: 70,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 24
  },
  brand: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    textDecoration: "none"
  },
  badge: {
    height: 40,
    width: "auto",
    display: "block"
  },
  wm: {
    fontFamily: "var(--font-display)",
    fontWeight: 900,
    fontSize: 19,
    letterSpacing: ".01em",
    textTransform: "uppercase",
    color: "var(--iag-ink)"
  },
  nav: {
    display: "flex",
    gap: 26,
    alignItems: "center"
  },
  navLink: {
    fontFamily: "var(--font-body)",
    fontWeight: 600,
    fontSize: 14.5,
    color: "var(--iag-ink)",
    textDecoration: "none",
    cursor: "pointer"
  },
  icons: {
    display: "flex",
    gap: 6,
    alignItems: "center"
  },
  iconBtn: {
    width: 42,
    height: 42,
    borderRadius: "50%",
    border: "none",
    background: "transparent",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
    color: "var(--iag-ink)"
  },
  cartCount: {
    position: "absolute",
    top: 4,
    right: 4,
    minWidth: 18,
    height: 18,
    padding: "0 5px",
    borderRadius: 9,
    background: "var(--iag-terracotta)",
    color: "#fff",
    fontFamily: "var(--font-display)",
    fontWeight: 800,
    fontSize: 10,
    display: "grid",
    placeItems: "center"
  }
};
function Header({
  cartCount,
  onCartOpen
}) {
  return /*#__PURE__*/React.createElement("header", {
    style: topStyles.header
  }, /*#__PURE__*/React.createElement("div", {
    style: topStyles.headerInner
  }, /*#__PURE__*/React.createElement("a", {
    href: "#top",
    style: topStyles.brand
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/brand/icon-plant-ink.png",
    alt: "I Am Grounded",
    style: topStyles.badge
  }), /*#__PURE__*/React.createElement("span", {
    style: topStyles.wm
  }, "I Am Grounded")), /*#__PURE__*/React.createElement("nav", {
    style: topStyles.nav,
    className: "iag-desktop-nav"
  }, ["Shop Clusters", "Flavours", "Coffee Fruit", "Our Story"].map(l => /*#__PURE__*/React.createElement("a", {
    key: l,
    href: "#",
    style: topStyles.navLink
  }, l))), /*#__PURE__*/React.createElement("div", {
    style: topStyles.icons
  }, /*#__PURE__*/React.createElement("button", {
    style: topStyles.iconBtn,
    "aria-label": "Search"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "search",
    size: 21
  })), /*#__PURE__*/React.createElement("button", {
    style: {
      ...topStyles.iconBtn,
      position: "relative"
    },
    "aria-label": "Cart",
    onClick: onCartOpen
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "bag",
    size: 21
  }), cartCount > 0 && /*#__PURE__*/React.createElement("span", {
    style: topStyles.cartCount
  }, cartCount)))));
}
function Hero({
  onAdd
}) {
  const pills = ["71mg caffeine per bag", "4 serves · ~$1.74 a serve", "120g bag", "Plant-based", "Made in AUS"];
  return /*#__PURE__*/React.createElement("section", {
    id: "top",
    style: {
      background: "var(--iag-cream)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      padding: "clamp(40px,6vw,84px) var(--gutter)",
      display: "grid",
      gridTemplateColumns: "1.05fr 0.95fr",
      gap: "clamp(28px,5vw,64px)",
      alignItems: "center"
    },
    className: "iag-hero-grid"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "iag-eyebrow"
  }, "All natural superfruit clusters"), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontFamily: "var(--font-display)",
      fontWeight: 900,
      textTransform: "uppercase",
      fontSize: "var(--fs-display-xl)",
      lineHeight: 0.96,
      letterSpacing: "-0.02em",
      color: "var(--iag-ink)",
      margin: "16px 0 0",
      textWrap: "balance"
    }
  }, "Crunchy coffee fruit energy for active days."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "var(--font-body)",
      fontSize: "var(--fs-body-lg)",
      lineHeight: 1.5,
      color: "var(--text-body)",
      margin: "22px 0 0",
      maxWidth: "46ch"
    }
  }, "Superfruit Clusters are naturally caffeinated, plant-based snack bites made with upcycled coffee fruit, oats and real ingredients. One bag has as much caffeine as one cup of coffee."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap",
      gap: 9,
      margin: "26px 0 0"
    }
  }, pills.map((p, i) => /*#__PURE__*/React.createElement(DS.Pill, {
    key: p,
    tone: i === 0 ? "terracotta" : "outline",
    size: "sm"
  }, p))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap",
      gap: 12,
      margin: "30px 0 0"
    }
  }, /*#__PURE__*/React.createElement(DS.Button, {
    variant: "primary",
    size: "lg",
    iconRight: /*#__PURE__*/React.createElement(Icon, {
      name: "arrow-right",
      size: 18,
      color: "#fff"
    }),
    onClick: onAdd
  }, "Shop Clusters"), /*#__PURE__*/React.createElement(DS.Button, {
    variant: "outline",
    size: "lg"
  }, "Try both flavours"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: "-8% -6%",
      background: "var(--iag-sunrise-wash)",
      borderRadius: "var(--radius-2xl)",
      transform: "rotate(-3deg)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      borderRadius: "var(--radius-2xl)",
      overflow: "hidden",
      boxShadow: "var(--shadow-lg)",
      aspectRatio: "4/4.6"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/imagery/pack-banana-track.png",
    alt: "Athlete with Banana Coconut clusters trackside",
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      bottom: 22,
      left: -18
    },
    className: "iag-hero-stamp"
  }, /*#__PURE__*/React.createElement(DS.Pill, {
    shape: "circle",
    tone: "terracotta",
    value: "71mg",
    label: "Caffeine",
    size: "lg"
  })))));
}
function Moments() {
  const tiles = [{
    image: "../../assets/imagery/pack-banana-track.png",
    eyebrow: "Before you move",
    title: "Morning run",
    caption: "Clean energy before the miles."
  }, {
    image: "../../assets/imagery/banana-breakfast-bowl.png",
    eyebrow: "At breakfast",
    title: "Bowl topper",
    caption: "Crunch over yoghurt & fruit."
  }, {
    image: "../../assets/imagery/pack-choc-pool.png",
    eyebrow: "After training",
    title: "Recovery",
    caption: "Refuel and refocus."
  }, {
    image: "../../assets/imagery/choc-desk.png",
    eyebrow: "At your desk",
    title: "The 3pm dip",
    caption: "Beat the afternoon slump."
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--iag-sand)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: "var(--max-w)",
      margin: "0 auto",
      padding: "var(--section-y) var(--gutter)"
    }
  }, /*#__PURE__*/React.createElement(DS.SectionHeading, {
    eyebrow: "Choose your moment",
    title: "Made for the moments between the miles.",
    lead: "A crunchy, functional snack for morning runs, track sessions, bike stops, workdays and breakfast bowls."
  }), /*#__PURE__*/React.createElement("div", {
    className: "iag-moments-grid",
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(4,1fr)",
      gap: 18,
      marginTop: 38
    }
  }, tiles.map(t => /*#__PURE__*/React.createElement(DS.FeatureTile, _extends({
    key: t.title
  }, t, {
    height: 300
  }))))));
}
Object.assign(window, {
  IAGHeader: Header,
  IAGHero: Hero,
  IAGMoments: Moments
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/clusters-landing/sections-top.jsx", error: String((e && e.message) || e) }); }

__ds_ns.AccordionItem = __ds_scope.AccordionItem;

__ds_ns.FeatureTile = __ds_scope.FeatureTile;

__ds_ns.FlavourCard = __ds_scope.FlavourCard;

__ds_ns.ProductCard = __ds_scope.ProductCard;

__ds_ns.SectionHeading = __ds_scope.SectionHeading;

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Pill = __ds_scope.Pill;

__ds_ns.Tag = __ds_scope.Tag;

__ds_ns.Input = __ds_scope.Input;

__ds_ns.QuantityStepper = __ds_scope.QuantityStepper;

})();
